import {Component, Input} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';
import {PgCalculationResult} from '../../../../models/sales-pg.model';

@Component({
    selector: 'app-variant-radio-group',
    templateUrl: './variant-radio-group.component.html',
    styleUrls: ['./variant-radio-group.component.less'],
})
export class VariantRadioGroupComponent extends CustomFormControl {
    @Input() items: PgCalculationResult[] = [];

    public size = undefined;
}
